import styled from 'styled-components'
// themes
import { colors } from 'themes/index'

export const Header = styled.div`
  align-items: center;
  border-bottom: 1px solid ${colors.blue500};
  color: ${colors.blue500};
  display: flex;
  font-size: 16px;
  font-weight: bold;
  height: 32px;
  justify-content: space-between;
  margin-bottom: 16px;
  position: relative;
`

export const Fields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const ButtonWrapper = styled.div`
  margin-top: 40px;
  display: flex;
  gap: 12px;
`

export const RolloverSection = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  > div {
    width: 40px;
  }
`
